module.exports = __webpack_public_path__ + "static/media/Ropeze-SS-Folding-Cleat.9adab57d.jpg";